import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Badge, Col, Tab, Tabs } from "react-bootstrap";
import RcsTextBox from "./_RcsTextbox";
import ShortlinksList from "../../pages/Generic/_ShortlinksList";

const RcsMessageControl = ({
  name,
  values,
  setValues,
  onChange,
  fieldsInfo,
  listShortLinks,
}) => {
  useEffect(() => {
    console.log("RcsMessage", values.rcsmessage);
    let rcsWithTemplate = values.rcsmessage;
    let result;
    try {
      var pattern = RegExp("{(.*?)}", "g");
      while ((result = pattern.exec(rcsWithTemplate))) {
        // Do something with result[0].

        try {
          var currentK = fieldsInfo.filter(
            (item) => "{" + item.vc_keycolumn + "}" == result[0]
          );
          rcsWithTemplate = rcsWithTemplate.replace(
            result[0],
            currentK[0].vc_value
          );
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }

    setValues({
      ...values,
      ["rcstemplate"]: rcsWithTemplate.replaceAll("{", "").replaceAll("}", ""),
    });
  }, [values.rcsmessage]);
  const clickLink = (link) => {
    //  setMessageText(link);
    setValues({
      ...values,
      rcsmessage: values.rcsmessage + " " + link + " ",
    });
  };
  return (
    <>
      {/* <Row>
        <Col sm={12}>
          <div>
            <FloatingLabel label="Titulo" className="mb-3">
              <Form.Control
                type="text"
                name="rcstitulo"
                id="rcstitulo"
                value={values.rcstitulo}
                required
                onChange={(event) => {
                  onChange(event);
                }}
                placeholder="Ingrese un Titulo"
              />
            </FloatingLabel>
          </div>
        </Col>
      </Row> */}
      {/* <Row>
        <Col sm={12}>
          <div>
            <FloatingLabel label="Encabezado" className="mb-3">
              <Form.Control
                type="text"
                name="rcsheader"
                id="Encabezado"
                value={values.rcsheader}
                required
                onChange={(event) => {
                  onChange(event);
                }}
                placeholder="Ingrese una imagen para mostrarla en el mensaje"
              />
            </FloatingLabel>
          </div>
        </Col>
      </Row> */}
      <Col sm={12}>
        <RcsTextBox
          name={name}
          defaultValue={values.rcsmessage}
          changeHandler={onChange}
        />
      </Col>
      {/* <Col sm={12}>
        <label className="text-[20p] font-semibold">Mensaje Alternativo*</label>
        <FloatingLabel label="Mensaje Alternativo" className="mb-3">
          <Form.Control
            type="text"
            name="rcssmsmessage"
            id="rcssmsmessage"
            value={values.rcssmsmessage}
            required
            onChange={(event) => {
              onChange(event);
            }}
            placeholder="Ingrese un mensaje alternativo"
          />
        </FloatingLabel>
      </Col> */}

      <Col sm={12}>
        <Tabs id="fill-tab-example" className="tabsBottom" fill>
          <Tab eventKey="ShortLinks" title="Urls Cortas">
            {listShortLinks && (
              <div className="ShortLink" style={{ paddingTop: "10px" }}>
                <h6>
                  Al darle click se agregará la url corta relacionada con el
                  alias que aparece a continuación:
                </h6>
                <div className="AllLinks">
                  <>
                    {listShortLinks && (
                      <ShortlinksList
                        clickBadge={clickLink}
                        listShortLinks={listShortLinks}
                      />
                    )}
                  </>
                </div>
              </div>
            )}
          </Tab>

          <Tab eventKey="AddFields" title="Template">
            <div className="ShortLink" style={{ paddingTop: "10px" }}>
              <h6>
                Al darle click se agregará el campo relacionado con el alias que
                aparece a continuación:
              </h6>
              <div className="AllLinks">
                <>
                  {fieldsInfo &&
                    fieldsInfo.map((field) => {
                      return (
                        <>
                          <Badge
                            onClick={() => {
                              //   setMessageText(field.vc_keycolumn);
                              setValues({
                                ...values,
                                rcsmessage:
                                  values.rcsmessage +
                                  "{" +
                                  field.vc_keycolumn +
                                  "}",
                                parameters:
                                  (values.parameters
                                    ? values.parameters + " ,"
                                    : "") +
                                  field.vc_keycolumn +
                                  " ",
                              });
                            }}
                            bg="primary"
                          >
                            {field.vc_keycolumn}
                          </Badge>
                        </>
                      );
                    })}
                </>
              </div>
            </div>
          </Tab>
        </Tabs>
      </Col>
    </>
  );
};

RcsMessageControl.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldsInfo: PropTypes.array.isRequired,
  setValues: PropTypes.func.isRequired,
  listShortLinks: PropTypes.array.isRequired,
};

export default RcsMessageControl;
